import React from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { X } from "react-bootstrap-icons";
const ModalEnlargeImage = (props) => {
    const { popData, setPopData } = props;
    const handleModal = () => {
        setPopData({ show: false });
    }
    return (
        <Modal show={popData.show} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header style={{ backgroundColor: 'rgb(3 149 228)' }}>تصویر کالا<span onClick={handleModal} style={{ cursor: "pointer" }}>
                <X size={20} /></span>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: "#ededfb" }}>
                {popData.image &&
                    <img src={"data:image;base64," + popData.image} alt='' style={{ display: "block", margin: "auto", maxWidth: "100%" }} />}
                {popData.imageUrl &&
                    <img src={popData.imageUrl} alt='' style={{ display: "block", margin: "auto", maxWidth: "100%" }} />
                }
            </Modal.Body>
        </Modal>
    )
}
export default ModalEnlargeImage;